import styled from '@emotion/styled';
import { LG_SCREEN_MIN, MD_SCREEN_MIN } from '../../../modules/Styleguide';

export const ScrollToContainer = styled.div`
  &:before {
    margin-top: -146px;
    display: block;
    content: '';
    height: 146px;
    visibility: hidden;
  }

  @media (max-width: 880px) {
    &:before {
      margin-top: -124px;
      height: 124px;
    }
  }
`;
export const Section = styled.section`
  width: 100%;
  margin: 0 auto;
`;

export const SectionContent = styled.div`
  display: flex;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  p {
    font-size: 1.6rem;
    line-height: 2.6rem;
  }
  @media (min-width: ${MD_SCREEN_MIN}px) {
    padding-right: 65px;
    padding-left: 65px;
  }
  @media (min-width: ${LG_SCREEN_MIN}px) {
    padding-right: 70px;
    padding-left: 70px;
  }
`;

export const PageHeader = styled.h1`
  font-size: 3.4rem;
  @media (min-width: ${MD_SCREEN_MIN}px) {
    font-size: 4rem;
  }
  @media (min-width: ${LG_SCREEN_MIN}px) {
    font-size: 5rem;
  }
`;

export const SectionHeader = styled.h2`
  font-weight: bold;
  font-size: 2.4rem;
  margin-top: 0;
  margin-bottom: 30px;
  @media (min-width: ${MD_SCREEN_MIN}px) {
    font-size: 3rem;
  }
`;

export const ValuePropLabel = styled.h4`
  font-size: 1.4rem;
  text-transform: uppercase;
`;
